<template>
  <!-- ToDo 需要数据测试 -->
  <div>
    <van-nav-bar
      class="backBox"
      title="处罚通知"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="message_box">
        <div class="top-text">
          <div class="top-text-hint">
            <div class="msgBeforeTit">上报时间：</div>
            <div class="msgAfterText">{{ reportTime }}</div>
          </div>
          <div class="top-text-hint">
            <div class="msgBeforeTit">处罚通知：</div>
            <div class="msgAfterText">{{ punishNotice }}</div>
          </div>
          <div class="top-text-hint">
            <div class="msgBeforeTit">处罚结果：</div>
            <div class="msgAfterText">{{ punishResult }}</div>
          </div>
          <div class="top-text-hint">
            <div class="msgBeforeTit">处罚说明：</div>
            <div class="msgAfterText">{{ punishExplain }}</div>
          </div>
        </div>
        <div v-if="imgList && imgList.length > 0" class="img-list">
          <img
            v-for="(item, index) in imgList"
            class="img-list-item"
            :key="item.id"
            bindtap="preImage"
            :src="imgList[index]"
            mode="aspectFill"
          />
        </div>
        <div v-if="recordList && recordList.length > 0">
          <div class="text-list-title">练习记录</div>
          <div class="text-list">
            <div
              v-for="item in recordList"
              class="text-list-item"
              :key="item.id"
            >
              <div class="text-list-1">{{ item.date }}</div>
              <div class="text-list-2">{{ item.practice_time }}</div>
              <div class="text-list-3">{{ item.time_lag }}</div>
            </div>
          </div>
        </div>

        <!-- <div class="content-wrap">
          <div class="content-title">消息内容：</div>
          <span class="content-txt">{{ content }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import * as constant from '../../api/constant'

import { Toast } from 'vant'
export default {
  data () {
    return {
      createTime: '',
      content: '',
      detailObj: {},
      award_punish_id: '',
      reportTime: '',
      punishNotice: '',
      punishResult: '',
      punishExplain: '',
      imgList: [],
      recordList: []
    }
  },
  mounted () {
    this.detailObj = this.$route.query
    this.readMag(this.detailObj.id)
    this.getInfo()
  },
  computed: {

  },
  methods: {
    transformPunishText (info) {
      const dateStr = `${utils.formatTimeMDChinese(new Date(info.begin_time))} - ${utils.formatTimeMDChinese(new Date(info.end_time))}`
      switch (info.award_punish_type) {
        case 2:
          return `${dateStr}, ` + '每天扣除' + (Math.round(info.value / 60 * 100) / 100) + '个时长'
        case 3: {
          return `${dateStr}, ` + '取消预约资格'
        }
        case 4:
          return `${dateStr}, ` + '取消预约资格'
        case 5:
          if (info.month) {
            return '扣除' + info.month + '月' + (Math.round(info.value / 60 * 100) / 100) + '个时长'
          } else {
            return `${dateStr}, ` + '扣除' + (Math.round(info.value / 60 * 100) / 100) + '个时长'
          }
        case 6:
          return '取消本学期预约资格'
        case 7:
          return '警告一次'
      }
      return '-'
    },
    getInfo () {
      const para = {
        id: this.detailObj.id
      }
      let apiUrl = ''
      if (Number(this.detailObj.type) === constant.announceType.violate) {
        apiUrl = 'violatPunisheQuery'
      } else if (Number(this.detailObj.type) === constant.announceType.negative) {
        apiUrl = 'negativePunishQuery'
      } else if (Number(this.detailObj.type) === constant.announceType.empty) {
        apiUrl = 'emptyPunishQuery'
      } else if (Number(this.detailObj.type) === constant.announceType.unLockDoor) {
        apiUrl = 'unLockDoorPunishQuery'
      } else {
        Toast.fail('加载数据失败')
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      api
        .axiosRequest(api.urlList[apiUrl], para)
        .then((res) => {
          Toast.clear()

          if (res.code === common.resCode.OK) {
            let punishTypeText = ''; let imgList = []
            if (Number(this.detailObj.type) === constant.announceType.violate) {
              punishTypeText = '违规违纪处罚通知'
              imgList = res.pic_url_list
              if (imgList && imgList.length > 0) {
                imgList.forEach((item, index, arr) => {
                  arr[index] = api.getPicUrl(item)
                })
              }
            } else if (Number(this.detailObj.type) === constant.announceType.negative) {
              punishTypeText = '消极练习处罚通知'
            } else if (Number(this.detailObj.type) === constant.announceType.empty) {
              punishTypeText = '空占练习处罚通知'
            } else if (Number(this.detailObj.type) === constant.announceType.unLockDoor) {
              punishTypeText = '不关门签退处罚通知'
            }
            this.punishNotice = punishTypeText
            this.punishResult = this.transformPunishText(res)
            this.punishExplain = res.content
            this.imgList = imgList
            this.award_punish_id = res.award_punish_id
            this.reportTime = utils.formatZHYMDHM(utils.formatDate(res.create_time))
            this.queryList()
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    queryList () {
      // const createTime = ''
      const para = {
        award_punish_id: this.award_punish_id
      }
      let apiMethod = ''
      if (Number(this.detailObj.type) === constant.announceType.negative) {
        apiMethod = 'negativePunishDetails'
      } else if (Number(this.detailObj.type) === constant.announceType.empty) {
        apiMethod = 'emptyPunishDetails'
      } else if (Number(this.detailObj.type) === constant.announceType.unLockDoor) {
        apiMethod = 'unLockDoorPunishDetails'
      } else {
        return
      }
      api
        .axiosRequest(api.urlList[apiMethod], para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            const list = []
            const addTwoZero = function (c) {
              if (c < 10) {
                return '0' + c
              } else {
                return c
              }
            }
            if (!Array.isArray(res.list)) {
              return
            }
            if (Number(this.detailObj.type) === constant.announceType.empty) {
              res.list.forEach(ite => {
                const bbTime = new Date(ite.book_begin_time)
                const beTime = new Date(ite.book_end_time)
                const newitem = {
                  date: bbTime.getFullYear() + '/' + addTwoZero(bbTime.getMonth() + 1) + '/' + addTwoZero(bbTime.getDate()),
                  appointment_time: addTwoZero(bbTime.getHours()) + ':' +
                    addTwoZero(bbTime.getMinutes()) + '-' +
                    addTwoZero(beTime.getHours()) + ':' +
                    addTwoZero(beTime.getMinutes()),
                  practice_time: '',
                  time_lag: '/'
                }
                let inTime, outTime
                if (ite.in_time) {
                  inTime = new Date(ite.in_time)
                  newitem.practice_time = addTwoZero(inTime.getHours()) + ':' + addTwoZero(inTime.getMinutes())

                  let dif = (inTime.getTime() - bbTime.getTime()) / 1000
                  dif = (dif - dif % 60) / 60
                  newitem.time_lag = (dif >= 60 ? (Math.floor(dif / 60) + '小时') : '') +
                    (dif % 60 > 0 ? (dif % 60 + '分钟') : '')
                  if (!newitem.time_lag) {
                    newitem.time_lag = '0分钟'
                  }
                }
                if (ite.in_time || ite.out_time) {
                  newitem.practice_time += '-'
                }
                if (ite.out_time) {
                  outTime = new Date(ite.out_time)
                  newitem.practice_time += addTwoZero(outTime.getHours()) + ':' + addTwoZero(outTime.getMinutes())
                }

                if (!newitem.practice_time) {
                  newitem.practice_time = '未练习'
                }
                list.push(newitem)
              })
            } else if (Number(this.detailObj.type) === constant.announceType.negative) {
              res.list.forEach(ite => {
                const bbTime = new Date(ite.book_begin_time)
                const beTime = new Date(ite.book_end_time)
                const newitem = {
                  date: bbTime.getFullYear() + '/' + addTwoZero(bbTime.getMonth() + 1) + '/' + addTwoZero(bbTime.getDate()),
                  appointment_time: addTwoZero(bbTime.getHours()) + ':' +
                    addTwoZero(bbTime.getMinutes()) + '-' +
                    addTwoZero(beTime.getHours()) + ':' +
                    addTwoZero(beTime.getMinutes()),
                  practice_time: '',
                  time_lag: null
                }
                let inTime, outTime
                if (ite.in_time) {
                  inTime = new Date(ite.in_time)
                  newitem.practice_time = addTwoZero(inTime.getHours()) + ':' + addTwoZero(inTime.getMinutes())
                }
                if (ite.in_time || ite.out_time) {
                  newitem.practice_time += '-'
                }
                if (ite.out_time) {
                  outTime = new Date(ite.out_time)
                  newitem.practice_time += addTwoZero(outTime.getHours()) + ':' + addTwoZero(outTime.getMinutes())

                  if (inTime) {
                    let dif = (outTime.getTime() - inTime.getTime()) / 1000
                    dif = (dif - dif % 60) / 60
                    newitem.time_lag = (dif >= 60 ? (Math.floor(dif / 60) + '小时') : '') +
                      (dif % 60 > 0 ? (dif % 60 + '分钟') : '')
                    if (!newitem.time_lag) {
                      newitem.time_lag = '0分钟'
                    }
                  }
                }

                if (!inTime || !outTime) {
                  newitem.time_lag = '0分钟'
                }
                if (!newitem.practice_time) {
                  newitem.practice_time = '未练习'
                  newitem.time_lag = '/'
                }
                list.push(newitem)
              })
            } else if (Number(this.detailObj.type) === constant.announceType.unLockDoor) {
              res.list.forEach(ite => {
                const bbTime = new Date(ite.book_begin_time)
                const beTime = new Date(ite.book_end_time)
                const newitem = {
                  date: bbTime.getFullYear() + '/' + addTwoZero(bbTime.getMonth() + 1) + '/' + addTwoZero(bbTime.getDate()),
                  appointment_time: addTwoZero(bbTime.getHours()) + ':' +
                    addTwoZero(bbTime.getMinutes()) + '-' +
                    addTwoZero(beTime.getHours()) + ':' +
                    addTwoZero(beTime.getMinutes()),
                  practice_time: '',
                  time_lag: null
                }
                let inTime, outTime
                if (ite.in_time) {
                  inTime = new Date(ite.in_time)
                  newitem.practice_time = addTwoZero(inTime.getHours()) + ':' + addTwoZero(inTime.getMinutes())
                }
                if (ite.in_time || ite.out_time) {
                  newitem.practice_time += '-'
                }
                if (ite.out_time) {
                  outTime = new Date(ite.out_time)
                  newitem.practice_time += addTwoZero(outTime.getHours()) + ':' + addTwoZero(outTime.getMinutes())
                }

                if (!newitem.practice_time) {
                  newitem.practice_time = '未练习'
                }
                newitem.time_lag = ite.downpiano
                list.push(newitem)
              })
            }
            this.recordList = list
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    readMag () {
      const para = {
        announcement_id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.readMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {

          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .message_box {
      .top-text-hint{
    display: flex;
    // flex-shrink: 0;
}
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0.625rem 0.9375rem;
    background-color: #fff;
    color: #666;

    .create-time {
      display: flex;
      align-items: center;
      font-size: 1rem;
      color: #666;
    }
    .content-wrap {
      margin-top: 0.625rem;
      display: flex;
    }

    .content-title {
      white-space: nowrap;
      font-size: 1rem;
      color: #666;
    }

    .content-txt {
      font-weight: 300;
      font-size: 1rem;
    }
  }
}
</style>
